import React from 'react';
export function Footer() {
  return <footer className="bg-ink px-4 pb-32 pt-10 text-center text-white/70 sm:px-6" data-id="element-128" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-3xl" data-id="element-129" data-mp="3gg0za3iktxxn">
        <p className="font-serif text-lg font-bold text-white" data-id="element-130" data-mp="3gh3ng3oilm9v">Obesity Clinical Blueprint™</p>
        <p className="mt-1 text-sm" data-id="element-131" data-mp="32m1d94cmxar9">Created by Dr. Henry Wells · © 2026 · All rights reserved.</p>
        <p className="mt-5 text-xs leading-relaxed text-white/60" data-id="element-132" data-mp="36n3cvmagrotr">
          Obesity Clinical Blueprint™ is an educational reference and workflow organization resource for qualified
          healthcare professionals. It does not replace professional training, individualized clinical assessment,
          current evidence, official prescribing information, or applicable local guidelines. Clinical decisions remain
          the responsibility of the treating healthcare professional.
        </p>
      </div>
    </footer>;
}